import { camelCaseToPresentable } from '@app/utils/strings';

export const login403Error = 'We can\'t find an account with this username and password';

export const extendedFieldName = {
    mobilePhone: 'mobile phone number',
    homePhone: 'home phone number',
    company: 'company name',
};

export const getDisplayName = (fieldName: string): string =>
    extendedFieldName[fieldName.toLowerCase()] || camelCaseToPresentable(fieldName);

export const getRequiredFieldMessage = (fieldName: string): string => `Please provide your ${getDisplayName(fieldName)}.`;
export const getInvalidCharacterMessage = (fieldName: string): string => `Your ${getDisplayName(fieldName)} contains an invalid character.`;
export const getInvalidFieldMessage = (fieldName: string): string => `Please provide a valid ${getDisplayName(fieldName)}.`;
export const getMinCharsMessage = (fieldName: string, min: number): string =>
    `Your ${getDisplayName(fieldName)} must have at least ${min} characters.`;
export const getMaxCharsMessage = (fieldName: string, max: number): string =>
    `Your ${getDisplayName(fieldName)} cannot be longer than ${max} characters.`;

export const contactNumberRequiredMessage = 'A mobile or home phone number must be provided.';
export const passwordsDoNotMatchMessage = 'Passwords do not match.';
